import { ReportFormat } from "../../common/data/service-proxies";

export const reportFormats = [
    {
      id: ReportFormat.Pdf,
      name: "PDF",
    },
    {
      id: ReportFormat.Csv,
      name: "CSV",
    },
  ];